var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBluePencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#8676E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7929 21.5H11C10.8674 21.5 10.7402 21.4474 10.6464 21.3536C10.5527 21.2598 10.5 21.1327 10.5 21V18.2072C10.5 18.1415 10.5129 18.0765 10.5381 18.0158C10.5632 17.9551 10.6 17.9 10.6464 17.8536L18.1464 10.3536C18.2402 10.2598 18.3674 10.2072 18.5 10.2072C18.6326 10.2072 18.7598 10.2598 18.8536 10.3536L21.6464 13.1465C21.7402 13.2403 21.7929 13.3674 21.7929 13.5C21.7929 13.6327 21.7402 13.7598 21.6464 13.8536L14.1464 21.3536C14.1 21.4 14.0449 21.4369 13.9842 21.462C13.9236 21.4871 13.8586 21.5 13.7929 21.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12L20 15.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.968 21.4681L10.5317 18.0319",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePencil);
export default __webpack_public_path__ + "static/media/bluePencil.730d1ec10ae7c85bdae67fe9f7fd7b07.svg";
export { ForwardRef as ReactComponent };